import Vue from 'vue'
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Vuetify from 'vuetify'

import Default from './layouts/Default.vue'
import NoSidebar from './layouts/NoSidebar.vue'
import Result from './layouts/Result.vue'
import Empty from './layouts/Empty.vue'

import 'vuetify/dist/vuetify.min.css'
import './styles/theme.scss'
import './assets/pneuma-icons/icons/font/icons.css'

import firebase from 'firebase/app'
import Hotjar from 'vue-hotjar'
import Gtag from 'vue-gtag'

import i18n from './i18n'

const ENABLE_TRACKING = !window.location.href.includes('localhost')

Vue.use(Hotjar, {
  id: '2465003',
  isProduction: ENABLE_TRACKING
})

Vue.use(Gtag, {
  config: {
    id: 'G-5VF5RCSKFP'
  },
  enabled: ENABLE_TRACKING
}, router)

Vue.component('default-layout', Default)
Vue.component('no-sidebar-layout', NoSidebar)
Vue.component('result-layout', Result)
Vue.component('empty-layout', Empty)

Vue.use(VueFilterDateFormat)
Vue.use(Vuetify)

Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: 'AIzaSyBH8vKBagYzCG5ukMrQVLpKs9Q2JMj-4BI',
  authDomain: 'truchecks-na.firebaseapp.com',
  projectId: 'truchecks-na',
  storageBucket: 'truchecks-na.appspot.com',
  messagingSenderId: '591458787696',
  appId: '1:591458787696:web:ddf7e2c6de3b40331b2fb5'
}

firebase.initializeApp(firebaseConfig)

// Set language
const browserLang = window.navigator.language.slice(0, 2)
let lang = localStorage.getItem('TRUORA_LANGUAGE')
lang = !lang ? browserLang : lang
localStorage.setItem('TRUORA_LANGUAGE', lang)
i18n.locale = lang
i18n.silentTranslationWarn = true

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
